/* eslint-disable */
import { getLocale, experimentalStaticLocale } from '../runtime.js';

/** @typedef {import('../runtime.js').LocalizedString} LocalizedString */

/** @typedef {{}} Service_Telemedicine_AriaInputs */

const en_service_telemedicine_aria = /** @type {(inputs: Service_Telemedicine_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Link to Telemedicine service`)
};

const fr_service_telemedicine_aria = /** @type {(inputs: Service_Telemedicine_AriaInputs) => LocalizedString} */ () => {
	return /** @type {LocalizedString} */ (`Lien vers le service de télémédecine`)
};

/**
* | output |
* | --- |
* | "Link to Telemedicine service" |
*
* @param {Service_Telemedicine_AriaInputs} inputs
* @param {{ locale?: "en" | "fr" }} options
* @returns {LocalizedString}
*/
export const service_telemedicine_aria = /** @type {((inputs?: Service_Telemedicine_AriaInputs, options?: { locale?: "en" | "fr" }) => LocalizedString) & import('../runtime.js').MessageMetadata<Service_Telemedicine_AriaInputs, { locale?: "en" | "fr" }, {}>} */ ((inputs = {}, options = {}) => {
	const locale = experimentalStaticLocale ?? options.locale ?? getLocale()
	if (locale === "en") return en_service_telemedicine_aria(inputs)
	return fr_service_telemedicine_aria(inputs)
});